import { DataBean } from "../DataBean";

export class MaterialAvailableProductionSelect extends DataBean {


    public async getRawMaterialAvailableProductionOrderCatalog(idProductionOrder:any,year:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getRawMaterialAvailableProductionOrderCatalogByYear_Number_Number", [idProductionOrder,year]);
    }



}